import { Fragment, h } from "@stencil/core";
import localI18n from "../../../util/i18n";
import { JwtUtil } from "../../../util/jwt-util/jwt-util";
import { getIconByStorklevel } from "../../../util/stork-icon-util";
export class AuthLevelWithStatus {
    constructor() {
        this.status = undefined;
        this.storkLevel = undefined;
    }
    render() {
        return (h(Fragment, { key: '25451398e925e72c70037165dd6ea05e1431c18d' }, h("div", { key: 'fd267f01bc281764ac3e809803d75daadd7285ef', class: `${getIconByStorklevel(this.storkLevel)} ${this.status === 'current' ? 'ba-trust-current' : ''}`, "aria-expanded": "false", "aria-label": `${this.status === 'current' ? localI18n.t('AKTUELL') + ': ' : ''}${localI18n.t('VERTRAUENSNIVEAU')} ${JwtUtil.authnLevels.get(this.storkLevel)}` }, this.status === 'current' ? (h("span", { style: { textTransform: 'uppercase' }, "aria-hidden": "true" }, localI18n.t('AKTUELL'))) : (''))));
    }
    static get is() { return "auth-level-with-status"; }
    static get properties() {
        return {
            "status": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "AuthLevelStatus",
                    "resolved": "\"current\" | \"inactive\"",
                    "references": {
                        "AuthLevelStatus": {
                            "location": "local",
                            "path": "/builds/oiam-client-support-group/oiam-session-timer-wc/src/components/authn-level-shield/auth-level-with-status/auth-level-with-status.tsx",
                            "id": "src/components/authn-level-shield/auth-level-with-status/auth-level-with-status.tsx::AuthLevelStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "'current', when this is the shield to display, 'inactive' otherwise"
                },
                "attribute": "status",
                "reflect": false
            },
            "storkLevel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "AuthnLevel",
                    "resolved": "\"STORK-QAA-Level-1\" | \"STORK-QAA-Level-2\" | \"STORK-QAA-Level-3\" | \"STORK-QAA-Level-4\"",
                    "references": {
                        "AuthnLevel": {
                            "location": "import",
                            "path": "@oiambk/oiam-oauth-types",
                            "id": "node_modules::AuthnLevel"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The AuthnLevel for which a shield is to be displayed"
                },
                "attribute": "stork-level",
                "reflect": false
            }
        };
    }
}
